import { useContext } from 'react'

import { refundMethods } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'

import GiftCardMessage from '../GiftCardMessage/GiftCardMessage'
import OriginalPaymentMethodMessage from '../OriginalPaymentMethodMessage/OriginalPaymentMethodMessage'
import StoreCreditMessage from '../StoreCreditMessage/StoreCreditMessage'

const CancellationsPortalMessage = ({ refundType, orderAmount, issueRefundAtStatus }) => {
  const { context } = useContext(AppContext)
  const amount = orderAmount?.remaining_amount
  const sharedProps = {
    storeName: context?.merchantInfo?.name,
    amount,
    instant: false,
    currency: orderAmount?.currency,
    storeCurrency: context?.merchantInfo?.currency,
    amountInStoreCurrency: orderAmount?.remaining_amount_in_store_currency,
    issueRefundAtStatus,
    isCancellationsPortal: true,
  }

  if (refundType === refundMethods.originalPaymentMethod) {
    return (
      <OriginalPaymentMethodMessage
        amount={amount}
        instant={false}
        currency={orderAmount?.currency}
        issueRefundAtStatus={issueRefundAtStatus}
        isCancellationsPortal
      />
    )
  }

  if (refundType === refundMethods.storeCredit) {
    return <StoreCreditMessage {...sharedProps} />
  }

  if (refundType === refundMethods.giftCard) {
    return <GiftCardMessage {...sharedProps} />
  }

  return null
}

export default CancellationsPortalMessage
